var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    { staticClass: "container" },
    [
      _c(
        "el-dialog",
        {
          staticStyle: { "font-weight": "bold" },
          attrs: {
            title:
              _vm.$t("user.userInfo") == "账户信息"
                ? _vm.userTitle
                : _vm.userTitle1,
            visible: _vm.userInfoDialog,
            top: "3%",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "before-close": _vm.handleClose,
            id: "userDetail"
          },
          on: {
            "update:visible": function($event) {
              _vm.userInfoDialog = $event
            }
          }
        },
        [
          _c("div", { staticClass: "top_main_line" }),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.editFlag,
                  expression: "editFlag"
                }
              ],
              staticClass: "top_user_form"
            },
            [
              _c(
                "el-form",
                { attrs: { "label-position": "top", "label-width": "80px" } },
                [
                  _c(
                    "div",
                    { staticClass: "top_user_marin" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("register.userName") } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "320px" },
                            attrs: {
                              readonly: "",
                              placeholder: _vm.$t("user.placeholder")
                            },
                            model: {
                              value: _vm.user.username,
                              callback: function($$v) {
                                _vm.$set(_vm.user, "username", $$v)
                              },
                              expression: "user.username"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "top_user_marin reg_top" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("register.fullName") } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "320px" },
                            attrs: {
                              placeholder: _vm.$t("register.fullName1")
                            },
                            model: {
                              value: _vm.user.name,
                              callback: function($$v) {
                                _vm.$set(_vm.user, "name", $$v)
                              },
                              expression: "user.name"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "top_user_marin" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("register.phone") } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "320px" },
                            attrs: {
                              readonly: "",
                              placeholder: _vm.$t("register.phone1")
                            },
                            model: {
                              value: _vm.user.phone,
                              callback: function($$v) {
                                _vm.$set(_vm.user, "phone", $$v)
                              },
                              expression: "user.phone"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "top_user_marin reg_top" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("register.email") } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "320px" },
                            attrs: { placeholder: _vm.$t("register.email1") },
                            model: {
                              value: _vm.user.email,
                              callback: function($$v) {
                                _vm.$set(_vm.user, "email", $$v)
                              },
                              expression: "user.email"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "top_user_marin" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("register.unitName") } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: _vm.$t("register.unitName1")
                            },
                            model: {
                              value: _vm.user.unit,
                              callback: function($$v) {
                                _vm.$set(_vm.user, "unit", $$v)
                              },
                              expression: "user.unit"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.editFlag,
                  expression: "!editFlag"
                }
              ],
              staticClass: "top_detail"
            },
            [
              _c("div", { staticClass: "top_detail_content" }, [
                _c("div", { staticClass: "user_content" }, [
                  _c("span", { staticClass: "span_1" }, [
                    _vm._v(_vm._s(_vm.$t("register.userName")) + "：")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "span_2" }, [
                    _vm._v(_vm._s(_vm.user.username))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "user_content" }, [
                  _c("span", { staticClass: "span_1" }, [
                    _vm._v(_vm._s(_vm.$t("register.fullName")) + "：")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "span_2" }, [
                    _vm._v(_vm._s(_vm.user.name))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "user_content" }, [
                  _c("span", { staticClass: "span_1" }, [
                    _vm._v(_vm._s(_vm.$t("register.phone")) + "：")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "span_2" }, [
                    _vm._v(_vm._s(_vm.user.phone))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "user_content" }, [
                  _c("span", { staticClass: "span_1" }, [
                    _vm._v(_vm._s(_vm.$t("register.email")) + "：")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "span_2" }, [
                    _vm._v(_vm._s(_vm.user.email))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "user_content" }, [
                  _c("span", { staticClass: "span_1" }, [
                    _vm._v(_vm._s(_vm.$t("register.unitName")) + "：")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "span_2" }, [
                    _vm._v(_vm._s(_vm.user.unit))
                  ])
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c("div", {
            staticClass: "top_main_line",
            staticStyle: { "margin-top": "0px" }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "detail_btn" },
            [
              _c(
                "el-button",
                {
                  staticClass: "btn_1",
                  attrs: { type: "primary" },
                  on: { click: _vm.handleClose }
                },
                [
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.editFlag,
                          expression: "editFlag"
                        }
                      ]
                    },
                    [_vm._v(_vm._s(_vm.$t("operate.cancel")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.editFlag,
                          expression: "!editFlag"
                        }
                      ]
                    },
                    [_vm._v(_vm._s(_vm.$t("operate.backPage")))]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.editFlag,
                      expression: "!editFlag"
                    }
                  ],
                  staticClass: "btn_2",
                  attrs: { type: "primary" },
                  on: { click: _vm.editClick }
                },
                [_c("span", [_vm._v(_vm._s(_vm.$t("operate.edit")))])]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.editFlag,
                      expression: "editFlag"
                    }
                  ],
                  staticClass: "btn_2",
                  attrs: { type: "primary" },
                  on: { click: _vm.saveRegisterUser }
                },
                [_c("span", [_vm._v(_vm._s(_vm.$t("operate.save")))])]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticStyle: { "font-weight": "bold" },
          attrs: {
            title: _vm.$t("operate.tips"),
            visible: _vm.tipsdDialog,
            top: "3%",
            width: "400px",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "show-close": false,
            "before-close": _vm.handleClose,
            id: "updatePassword"
          },
          on: {
            "update:visible": function($event) {
              _vm.tipsdDialog = $event
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "top_user_form",
              staticStyle: { width: "400px", height: "22px" }
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("operate.resetPasswordTips")) +
                  "\n      "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "detail_btn1" },
            [
              _c(
                "el-button",
                {
                  staticClass: "btn_2",
                  attrs: { type: "primary" },
                  on: { click: _vm.determineDialog }
                },
                [_c("span", [_vm._v(_vm._s(_vm.$t("operate.determine")))])]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticStyle: { "font-weight": "bold" },
          attrs: {
            title: _vm.$t("top.changePassword"),
            visible: _vm.updatePsdDialog,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            top: "3%",
            "before-close": _vm.handleClose,
            id: "updatePassword"
          },
          on: {
            "update:visible": function($event) {
              _vm.updatePsdDialog = $event
            }
          }
        },
        [
          _c("div", {
            staticClass: "top_main_line",
            staticStyle: { width: "368px" }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "top_user_form",
              staticStyle: { width: "368px", height: "390px" }
            },
            [
              _c(
                "el-form",
                { attrs: { "label-position": "top", "label-width": "80px" } },
                [
                  _c(
                    "div",
                    { staticClass: "top_user_marin" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("register.initPassword") } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "320px" },
                            attrs: {
                              type: "password",
                              placeholder: _vm.$t("register.initPassword1")
                            },
                            model: {
                              value: _vm.resetPwd.oldPwd,
                              callback: function($$v) {
                                _vm.$set(_vm.resetPwd, "oldPwd", $$v)
                              },
                              expression: "resetPwd.oldPwd"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "top_user_marin" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("top.newPassword") } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "320px" },
                            attrs: {
                              type: "password",
                              placeholder: _vm.$t("top.newPassword1")
                            },
                            model: {
                              value: _vm.resetPwd.newPwd,
                              callback: function($$v) {
                                _vm.$set(_vm.resetPwd, "newPwd", $$v)
                              },
                              expression: "resetPwd.newPwd"
                            }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "pass_tip" }, [
                            _vm._v(_vm._s(_vm.$t("top.passwordTip")))
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "top_user_marin",
                      staticStyle: { clear: "both" }
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("top.confirmPassword") } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "320px" },
                            attrs: {
                              type: "password",
                              placeholder: _vm.$t("top.confirmPassword1")
                            },
                            model: {
                              value: _vm.resetPwd.entPwd,
                              callback: function($$v) {
                                _vm.$set(_vm.resetPwd, "entPwd", $$v)
                              },
                              expression: "resetPwd.entPwd"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", {
            staticClass: "top_main_line",
            staticStyle: { "margin-top": "0px", width: "368px" }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "detail_btn", staticStyle: { width: "368px" } },
            [
              _c(
                "el-button",
                {
                  staticClass: "btn_1",
                  attrs: { type: "primary" },
                  on: { click: _vm.handleClose }
                },
                [_c("span", [_vm._v(_vm._s(_vm.$t("operate.cancel")))])]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "btn_2",
                  attrs: { type: "primary" },
                  on: { click: _vm.savePassword }
                },
                [_c("span", [_vm._v(_vm._s(_vm.$t("operate.determine")))])]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "shortcut" }, [
        _c("div", { staticClass: "wrapper" }, [
          _c("div", { staticClass: "logo", on: { click: _vm.goIndex } }, [
            _c("img", { attrs: { src: require("../assets/images/logo.png") } }),
            _vm._v("-->\n        ")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "title" }, [
            _c(
              "ul",
              {
                staticClass: "font_size20 font_jzc",
                staticStyle: {
                  "font-weight": "600",
                  color: "#272D2D",
                  cursor: "pointer"
                }
              },
              [
                _c(
                  "li",
                  {
                    class: _vm.clickBag == "n" ? "top_click" : "",
                    on: {
                      click: function($event) {
                        return _vm.ngClick("n")
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("product.ngName")))]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    class: _vm.clickBag == "a" ? "top_click" : "",
                    staticStyle: { "margin-left": "60px" },
                    on: {
                      click: function($event) {
                        return _vm.auClick("a")
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("product.auName")))]
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "ul",
            { staticStyle: { "margin-right": "180px" } },
            [
              _c(
                "li",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.user.username,
                      expression: "!user.username"
                    }
                  ],
                  on: { click: _vm.loginClick }
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "font_size24 font_jzh",
                      staticStyle: { "font-weight": "500", color: "#272D2D" },
                      attrs: { href: "#" }
                    },
                    [_vm._v(_vm._s(_vm.$t("user.login")))]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        !_vm.user.username &&
                        _vm.settingColumn.registrationSwitch == 0,
                      expression:
                        "!user.username && settingColumn.registrationSwitch==0"
                    }
                  ],
                  on: { click: _vm.registerClick }
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "font_size24 font_jzh",
                      staticStyle: { "font-weight": "500", color: "#272D2D" },
                      attrs: { href: "#" }
                    },
                    [_vm._v(_vm._s(_vm.$t("user.register")))]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "el-dropdown",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.user.name,
                      expression: "user.name"
                    }
                  ],
                  staticStyle: {
                    "margin-top": "10px",
                    "margin-left": "16px",
                    cursor: "pointer"
                  },
                  attrs: { trigger: "click" }
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "el-dropdown-link font_size24 font_jzh",
                      staticStyle: { "font-weight": "500", color: "#272D2D" }
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.user.name) +
                          "\n                 "
                      ),
                      _c("i", {
                        staticClass: "el-icon-arrow-down el-icon--right"
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-dropdown-menu",
                    {
                      staticClass: "dropdownPop",
                      attrs: { slot: "dropdown" },
                      slot: "dropdown"
                    },
                    [
                      _c("el-dropdown-item", [
                        _c("div", { on: { click: _vm.myOrder } }, [
                          _vm._v(_vm._s(_vm.$t("top.myOrder")))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("el-dropdown-item", [
                        _c("div", { on: { click: _vm.userDetail } }, [
                          _vm._v(_vm._s(_vm.$t("top.accountDetails")))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("el-dropdown-item", [
                        _c("div", { on: { click: _vm.updatePassword } }, [
                          _vm._v(_vm._s(_vm.$t("top.changePassword")))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("el-dropdown-item", [
                        _c("div", { on: { click: _vm.logout } }, [
                          _vm._v(_vm._s(_vm.$t("top.logOut")))
                        ])
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-dropdown",
                {
                  staticStyle: {
                    "margin-top": "10px",
                    "margin-left": "16px",
                    cursor: "pointer"
                  },
                  on: { command: _vm.changeLanguage }
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "el-dropdown-link font_size24 font_jzh",
                      staticStyle: { "font-weight": "500", color: "#272D2D" }
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("language.name")) +
                          "\n                 "
                      ),
                      _c("i", {
                        staticClass: "el-icon-arrow-down el-icon--right"
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-dropdown-menu",
                    { attrs: { slot: "dropdown" }, slot: "dropdown" },
                    [
                      _c("el-dropdown-item", { attrs: { command: "zh" } }, [
                        _vm._v("中文")
                      ]),
                      _vm._v(" "),
                      _c("el-dropdown-item", { attrs: { command: "en" } }, [
                        _vm._v("English")
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fade", mode: "out-in" } },
        [_c("router-view")],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-13988cab", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13988cab","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/top.vue
// module id = null
// module chunks = 